import React, { Component } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';

import theme from './styles/Theme'
import { withStyles } from '@material-ui/core/styles';
import Customers from './components/Customers'
import Login from './components/Login'
import Logo from './images/logo.png';
import InventoryLocation from './components/InventoryLocation';
import Accounts from './components/Accounts';
import Account from './components/Account';
import Customer from './components/Customer';
import Token from './components/Token';
import EditAccount from './components/EditAccount';
import EditCustomer from './components/EditCustomer';
import EditLogisticPlan from './components/EditLogisticPlan';

import { Provider } from 'mobx-react';
import store from './stores'
import { inject, observer } from 'mobx-react';
import createBrowserHistory from 'history/createBrowserHistory'

import {
  Router,
  Route,
  Redirect,
  Switch,
  Link
} from 'react-router-dom'

//Syncing browser history with HistoryStore
const history = createBrowserHistory()
history.listen(newHistory => store.historyStore.updateHistory(newHistory))

class App extends Component {

  logout(history){
    store.userStore.logout();
    history.push('/login');
  }

  render() {    
    const { classes } = this.props;
    
    return (
      <Provider store={store}>      
        <MuiThemeProvider theme={theme}>
          <Router history={history}>
            <div className={classes.root}>
              <AppBar position="static">
                <Toolbar>
                  <div className={classes.mainTitle}><Link to="/"><img alt='MagicAdd Logo' src={Logo}/></Link></div>
                  <Switch>
                  <Route path="/login"/>
                  <Route render={({history})=>
                    <Button color="inherit" onClick={()=>this.logout(history)}>Log out</Button>
                  }/>
                  </Switch>
                </Toolbar>

              </AppBar>
              <div className={classes.mainContent}>
                <Switch>
                  <Route exact path="/login" component={Login}/>
                  <PrivateRoute exact path="/customers" component={Customers}/>
                  <PrivateRoute exact path="/inventory_locations/:id" component={InventoryLocation}/>
                  <PrivateRoute exact path="/accounts" component={Accounts}/>
                  <PrivateRoute exact path="/accounts/:id/edit" component={EditAccount}/>
                  <PrivateRoute exact path="/accounts/:id" component={Account}/>
                  <PrivateRoute exact path="/accounts/:accountId/customers/new" render={props=><EditCustomer {...props} isNew={true}/>}/>
                  <PrivateRoute exact path="/customers/:id" component={Customer}/>
                  <PrivateRoute exact path="/customers/:id/edit" render={props=><EditCustomer {...props} new={false}/>}/>
                  <PrivateRoute exact path="/accounts/:accountId/logistic_plans/new" render={props=><EditLogisticPlan {...props} isNew={true}/>}/>
                  <PrivateRoute exact path="/accounts/:accountId/logistic_plans/:id" render={props=><EditLogisticPlan {...props} new={false}/>}/>
                  <PrivateRoute exact path="/groups/:campaignPrefix/tokens/:token" component={Token}/>
                  <Route render={()=><Redirect to="/accounts"/>}/>
                </Switch>
              </div>
            </div>
          </Router>
        </MuiThemeProvider>
      </Provider>
    );
  }
}
const styles = theme => ({
  mainTitle:{
    flex: 1
  },
  mainContent: {
    padding: 20,
  }
});

@inject('store')
@observer
class PrivateRoute extends React.Component{
  render(){
    const {component:Component, render, store, ...rest} = this.props;
    
    return(
      <Route {...rest} render={props => (
        store.userStore.isAuthenticated ? (
          render ? render() : <Component {...props}/>
        ) : (
          <Redirect to={{
            pathname: '/login',
            state: { from: props.location }
          }}/>
        )
      )}/>
  )}
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js